<template>
  <div>
    <my-head></my-head>
    <div class="minH recruit">
      <div class="crumbs">
        首页 > 关于我们 > 信息公开 >
        <span style="color: #1d2129">招聘信息</span>
      </div>
      <div class="title flex-center">{{ data.title }}</div>
      <el-divider></el-divider>
      <div v-html="data.content"></div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
import { getRequest } from "../../api/api";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      data: { title: "", content: "" },
    };
  },
  methods: {
    getData() {
      getRequest({ url: `/api/v1/career/${this.$route.query.id}` }).then(
        (res) => {
          this.data = res.data;
        }
      );
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss">
.recruit {
  width: 80%;
  margin: 24px auto 60px;
  .title {
    font-size: 24px;
  }
}
</style>
